'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$63() {
  this.aWY = null;
  this.aWZ = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$63 as $c_Lpresto_GroupRestrictionsView$$anon$63 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$63.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$63;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$63() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$63 as $h_Lpresto_GroupRestrictionsView$$anon$63 };
$h_Lpresto_GroupRestrictionsView$$anon$63.prototype = $p;
$p.P = (function() {
  if ((!this.aWZ)) {
    this.aWY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aWZ = true;
  }
  return this.aWY;
});
var $d_Lpresto_GroupRestrictionsView$$anon$63 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$63, "presto.GroupRestrictionsView$$anon$63", ({
  JF: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$63 as $d_Lpresto_GroupRestrictionsView$$anon$63 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$63.js.map
